import request from '../utils/request'

export function getPermissionTree() {
  return request({
    url: '/api/admin/permissions/tree',
    method: 'get'
  })
}
